import { render, staticRenderFns } from "./processCom.vue?vue&type=template&id=130777de&"
import script from "./processCom.vue?vue&type=script&lang=js&"
export * from "./processCom.vue?vue&type=script&lang=js&"
import style0 from "./processCom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "processCom.vue"
export default component.exports